import Icon from "@ant-design/icons";

import type { GetProps } from "antd";
type CustomIconComponentProps = GetProps<typeof Icon>;

const ReverseSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    viewBox="0 0 24 24"
  >
    <g
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth={1.5}
    >
      <path
        strokeMiterlimit={10}
        d="M6.395 7.705A7.9 7.9 0 0 1 12 5.382a7.93 7.93 0 0 1 7.929 7.929A7.94 7.94 0 0 1 12 21.25a7.94 7.94 0 0 1-7.929-7.94"
      ></path>
      <path
        strokeLinejoin="round"
        d="m7.12 2.75l-.95 3.858a1.33 1.33 0 0 0 .97 1.609l3.869.948"
      ></path>
    </g>
  </svg>
);

export const ReverseIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={ReverseSvg} {...props} />
);
export default ReverseIcon;
